import React, { useState } from "react";
import "./contact.css";
import axios from "axios";
import { BsFillWalletFill, BsWhatsapp } from "react-icons/bs";
import { FaPhone, FaTelegramPlane } from "react-icons/fa";
import { AiOutlineMail } from "react-icons/ai";
import { FiMail } from "react-icons/fi";
import { useRef } from "react";
import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ type: "", message: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ type: "", message: "" });

    try {
      const response = await axios.post(
        `https://quantum-assets-global-ledger-backend.vercel.app/api/contact/submit`,
        formData
      );

      if (response.data.status === 'ok') {
        setSubmitStatus({
          type: "success",
          message: "Message sent successfully! We'll get back to you soon."
        });
        // Clear form
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          message: ""
        });
      }
    } catch (error) {
      setSubmitStatus({
        type: "error",
        message: "Failed to send message. Please try again later."
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // sweet alert function
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  return (
    <div className="contact-container">
      <div className="contact-inner">
        <div className="contact-grid">
          <div className="form-section">
            <div className="form-container">
              <h2 className="form-title">Make Enquiry</h2>

              {submitStatus.message && (
                <div className={`alert ${submitStatus.type}`}>
                  {submitStatus.message}
                </div>
              )}

              <form onSubmit={handleSubmit} className="form">
                <div className="form-grid">
                  <div className="form-group">
                    <label htmlFor="firstName" className="form-label">
                      First name
                    </label>
                    <div className="input-container">
                      <input
                        id="firstName"
                        name="firstName"
                        type="text"
                        value={formData.firstName}
                        onChange={handleChange}
                        autoComplete="given-name"
                        className="form-input"
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="lastName" className="form-label">
                      Last name
                    </label>
                    <div className="input-container">
                      <input
                        id="lastName"
                        name="lastName"
                        type="text"
                        value={formData.lastName}
                        onChange={handleChange}
                        autoComplete="family-name"
                        className="form-input"
                        required
                      />
                    </div>
                  </div>
                  <div className="message-container">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <div className="input-container">
                      <input
                        id="email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        autoComplete="email"
                        className="form-input"
                        required
                      />
                    </div>
                  </div>

                  <div className="message-container">
                    <div className="message-header">
                      <label htmlFor="message" className="form-label">
                        How can we help you?
                      </label>
                      <p id="message-description" className="message-limit">
                        Max 500 characters
                      </p>
                    </div>
                    <div className="input-container">
                      <textarea
                        id="message"
                        name="message"
                        rows={4}
                        value={formData.message}
                        onChange={handleChange}
                        aria-describedby="message-description"
                        className="form-input"
                        maxLength={500}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="submit-container">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="submit-button launch-btn launch aos-init aos-animate"
                  >
                    {isSubmitting ? "Sending..." : "Send message"}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="image-section">
            <div className="image-container">
              <div className="image-wrapper">
                <img src="/Credit-Card-Mockup.png" alt="QFS Credit Card" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
